import { render } from "./MadeMedication.vue?vue&type=template&id=6d81698a"
import script from "./MadeMedication.vue?vue&type=script&lang=js"
export * from "./MadeMedication.vue?vue&type=script&lang=js"

import "./MadeMedication.vue?vue&type=style&index=0&id=6d81698a&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__